import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=74342e6d&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74342e6d')) {
      api.createRecord('74342e6d', component.options)
    } else {
      api.reload('74342e6d', component.options)
    }
    module.hot.accept("./Attachment.vue?vue&type=template&id=74342e6d&", function () {
      api.rerender('74342e6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Attachment.vue"
export default component.exports